import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import useI18n from '../i18n/useI18n';

const styles = theme => ({});

@withStyles(styles)
class ConfirmationDialog extends React.Component {
  handleCancel = () => {
    this.props.onCancel();
  };

  handleConfirm = () => {
    this.props.onConfirm();
  };

  handleClose = () => {
    this.props.onClose();
  };

  render() {
    const { title, children, onlyClose, i18n, ...other } = this.props;

    return (
      <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        maxWidth="xs"
        aria-labelledby={`confirmation-dialog-${title}`}
        {...other}
      >
        <DialogTitle id={`confirmation-dialog-${title}`}>{title}</DialogTitle>
        <DialogContent>{children}</DialogContent>
        <DialogActions>
          {!onlyClose && (
            <React.Fragment>
              <Button onClick={this.handleCancel} color="primary">
                {i18n.t('confirmation.cancel')}
              </Button>
              <Button
                variant="contained"
                onClick={this.handleConfirm}
                color="primary"
              >
                {i18n.t('confirmation.confirm')}
              </Button>
            </React.Fragment>
          )}
          {onlyClose && (
            <Button color="primary" onClick={this.handleClose}>
              {i18n.t('confirmation.close')}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    );
  }
}

const ConfirmationDialogWithI18n = props => {
  const i18n = useI18n();
  return <ConfirmationDialog i18n={i18n} {...props} />;
};

export default ConfirmationDialogWithI18n;
